export default __webpack_public_path__ + "waiting-decline.fcfc018657ac0888.svg";